import { Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface ITextInformation {
  title: string;
  description: string;
}
export const TextInformation = ({ title, description }: ITextInformation) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      gap={isDesktop ? '6px' : '4px'}
      padding={isDesktop ? undefined : '0 16px'}
    >
      <Typography variant='body1' maxWidth='300px' component='h3'>
        {title}
      </Typography>
      <Typography
        variant={isDesktop ? 'body6' : 'body3'}
        color='text.secondary'
      >
        {description}
      </Typography>
    </Stack>
  );
};
